import type {RouteLocationNormalizedGeneric} from 'vue-router';

export const canGoGuard = (to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  if (!to?.meta?.canGo) {
    return true;
  }

  const canGo = to.meta.canGo.every((callback) => callback());

  if (canGo) {
    return true;
  }

  return {name: 'dashboard'};
};
